/**
 *
 * @param date1
 * @param date2
 * @returns true if date1 is smaller than date2
 */
export const CompareTwoDates = (date1: Date, date2: Date): boolean => {
    return (
        date1.getFullYear() < date2.getFullYear() ||
        (date1.getFullYear() === date2.getFullYear() && date1.getMonth() < date2.getMonth()) ||
        (date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() < date2.getDate())
    );
};

// returns true if two dates are equal
export const CompareTwoDatesEquality = (date1: Date, date2: Date): boolean => {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
};

export const CompareTwoTimes = (date1: Date, date2: Date): boolean => {
    return (
        date1.getHours() < date2.getHours() ||
        (date1.getHours() === date2.getHours() && date1.getMinutes() < date2.getMinutes())
    );
};

export const CompareTwoTimesEquality = (date1: Date, date2: Date): boolean => {
    return date1.getHours() === date2.getHours() && date1.getMinutes() === date2.getMinutes();
}; /**
 *  returns true if date1 is smaller than (or equal) to date2
 * @param date1
 * @param date2
 * @param includeEquality
 * @returns
 */
export const CompareTwoDateTimes = (date1: Date, date2: Date, includeEquality: boolean): boolean => {
    const lessThan =
        CompareTwoDates(date1, date2) || (CompareTwoDatesEquality(date1, date2) && CompareTwoTimes(date1, date2));
    if (includeEquality) {
        const equalTo = CompareTwoDatesEquality(date1, date2) && CompareTwoTimesEquality(date1, date2);
        return lessThan || equalTo;
    }
    return lessThan;
};

/**
 * Returns true if date1 is equal to date2 (includes dates and times)
 * @param date1
 * @param date2
 * @param includeEquality
 * @returns
 */
export const CompareTwoDateTimesEquality = (date1: Date, date2: Date): boolean => {
    return CompareTwoDatesEquality(date1, date2) && CompareTwoTimesEquality(date1, date2);
};

export const FormatDateText = (date: Date): string => {
    if (!date) {
        return '';
    }
    const dateView =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
        '.' +
        (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) +
        '.' +
        date.getFullYear() +
        '.';
    return dateView;
};

export const FormatTimeText = (date: Date): string => {
    if (!date) {
        return '';
    }
    const timeView =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) +
        ':' +
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    return timeView;
};
